import { render } from "./SelectedDetail.vue?vue&type=template&id=4887c5ce&scoped=true"
import script from "./SelectedDetail.vue?vue&type=script&lang=js"
export * from "./SelectedDetail.vue?vue&type=script&lang=js"

import "./SelectedDetail.vue?vue&type=style&index=0&id=4887c5ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4887c5ce"]])

export default __exports__